export interface InvoiceData {
    id: string;
    avatar: string;
    billingDate: string;
    amount: string;
    invoiceNo: string;
    details: string

}
export const myCompanyInvoiceData: InvoiceData[] = [
    {
        id: "1",
        avatar: "Avatar",
        billingDate: "Billing Date",
        amount: "Amount",
        invoiceNo: "Invoice #",
        details: 'Details'
    }
]
export const InvoiceTableData = [
    {
        listId: "1",
        avatar: require("../assets/setting/mycompany/invoces/Ellipse 27.png"),
        billingDate: "09/13/2022",
        amount: "$607.15",
        invoiceNo: "INVO123456789",
        details: require("../assets/setting/mycompany/invoces/Group.png"),

    },
    {
        listId: "2",
        avatar: require("../assets/setting/mycompany/invoces/Ellipse 28.png"),
        billingDate: "09/13/2022",
        amount: "$607.15",
        invoiceNo: "INVO123456789",
        details: require("../assets/setting/mycompany/invoces/Group.png"),
    },
    {
        listId: "3",
        avatar: require("../assets/setting/mycompany/invoces/Ellipse 29.png"),
        billingDate: "09/13/2022",
        amount: "$607.15",
        invoiceNo: "INVO123456789",
        details: require("../assets/setting/mycompany/invoces/Group.png"),
    },
    {
        listId: "4",
        avatar: require("../assets/setting/mycompany/invoces/Ellipse 30.png"),
        billingDate: "09/13/2022",
        amount: "$607.15",
        invoiceNo: "INVO123456789",
        details: require("../assets/setting/mycompany/invoces/Group.png"),
    },
    {
        listId: "5",
        avatar: require("../assets/setting/mycompany/invoces/Ellipse 31.png"),
        billingDate: "09/13/2022",
        amount: "$607.15",
        invoiceNo: "INVO123456789",
        details: require("../assets/setting/mycompany/invoces/Group.png"),
    },
    {
        listId: "6",
        avatar: require("../assets/setting/mycompany/invoces/Ellipse 32.png"),
        billingDate: "09/13/2022",
        amount: "$607.15",
        invoiceNo: "INVO123456789",
        details: require("../assets/setting/mycompany/invoces/Group.png"),
    },
    {
        listId: "7",
        avatar: require("../assets/setting/mycompany/invoces/Ellipse 33.png"),

        billingDate: "09/13/2022",
        amount: "$607.15",
        invoiceNo: "INVO123456789",
        details: require("../assets/setting/mycompany/invoces/Group.png"),
    }

]
export const pdfDetails = {
    invoiceNo: ' INV01230925',
    totalAmount: "£20.00",
    descPCNNo: 'PCN-876343232',
    descDate: '07/07/2021 - 01/01/2022',
    headerContact: ["647-44-1234", "info@drivertok.co.uk", "drivertok.co.uk"],
    headerAddress: ["Suite 6 Office I-K, 6-9", "The Square, Stockley", "Park,Uxbridge, England,", "UB11 1FW"],
    billedTo: ["Jayden Smith", "Jayed.S@gmail.com", "4 Roundwood Avenue", "#82 Hayes, Uxbridge,", "UB11 1AF Uk"],
    Customer: ["Sophia Taylor", "Sophe.t@gmail.com", "BP, Mansfield Road, Wales,Sheffield, South Yorkshire,England, S26 5, GBR"],
    invoiceDetails: [{ invoiceTotAmount: "£4520.00", name: "INVO123654977", color: '', fw: '' }, { name: 'Date Of Issue', color: '', fw: '600' }, { name: "10/07/22", color: '#6E7191', fw: '' }, { name: "Payment Date", color: '', fw: '600' }, { name: "19/07/22", color: '#6E7191', fw: '' }],
    invoiceTotalAmount: ["£4520.00"]

}

export const billingContact = [
    {
        image: require('../assets/setting/mycompany/contact1.png'),
        name: 'Cameron Williamson',
        role: 'CEO'
    },
    {
        image: require('../assets/setting/mycompany/contact1.png'),
        name: 'Jayden Smith',
        role: 'HR Admin',
    },
    {
        image: require('../assets/setting/mycompany/contact2.png'),
        name: 'Sophia Taylor  ',
        role: 'PBO',
    },
    {
        image: require('../assets/setting/mycompany/contact2.png'),
        name: 'Sophia Taylor',
        role: 'HR Lead ',
    },
]
export const Description: any = [
    {
        AdvantagePrice: "07/07/2021 - 01/01/2022",
        unitCost: "100",
        QtyRate: "1",
        amount: "1000",
    },
    {
        AdvantagePrice: "07/07/2021 - 01/01/2022",
        unitCost: "100",
        QtyRate: "1",
        amount: "1000",
    },
    {
        AdvantagePrice: "07/07/2021 - 01/01/2022",
        unitCost: "100",
        QtyRate: "1",
        amount: "1000",
    },
    {
        AdvantagePrice: "07/07/2021 - 01/01/2022",
        unitCost: "100",
        QtyRate: "1",
        amount: "1000",
    }
]

export const modalFooter: any = [
    {

        Subtotal: "£4000.00",
        Tax: "£520.00",
        Total: "£4520.00",
        AmountDue: "£4520.00"
    }
]
